import { useState } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';

import ModalViewPDF from 'components/UI/ModalViewPDF/ModalViewPDF';
import classes from './ShowDiploma.module.css';

const ShowDiploma = props => {
  const [openDiploma, setOpenDiploma] = useState(false);
  const [urlDiploma, setUrlDiploma] = useState('');

  const openDiplomaHandler = url => () => {
    axios({
      url,
      method: 'GET'
    }).then(response => {
      const urlDiploma = response.data.location;
      setOpenDiploma(true);
      setUrlDiploma(urlDiploma);
    });
  };

  const closeDiplomaHandler = () => {
    setOpenDiploma(false);
  };

  // TODO revisar que se muestre el botón del diploma hasta que el usuario termine el curso

  return (
    <aside className={classes.showDiplomaContainer}>
      {props.dataCertificate && props.dataCertificate.isDiploma && (
        <Button
          className={classes.showDiplomaBtn}
          onClick={openDiplomaHandler(props.dataCertificate.url)}
        >
          <figure className={classes.iconIncludesContainer}>
            <img
              className={classes.img}
              src="https://d1g6c01s9ssd7h.cloudfront.net/img/consulta_diploma.png"
            />
          </figure>
          Consulta tu diploma aquí
        </Button>
      )}
      <ModalViewPDF
        urlCloudFront={urlDiploma}
        openModal={openDiploma}
        onCloseModal={closeDiplomaHandler}
        urlViewPDF={urlDiploma}
        titlePDF="Vista del Diploma"
        titleCourse={props.titleCourse}
        endDate={props.dataCertificate.endDate}
        URLShare={props.dataCertificate.urlShare}
      />
    </aside>
  );
};

ShowDiploma.propTypes = {
  // eslint-disable-next-line react/require-default-props
  dataCertificate: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  titleCourse: PropTypes.string
};

export default ShowDiploma;
